import { type ReactNode } from 'react'

import { UserGroupIcon } from '@ds/components'

import styles from './CollectionHeroFollow.module.css'

export const COLLECTION_HERO_FOLLOW_TEST_ID = 'collection-hero-follow'

export type TCollectionHeroFollowProps = {
    followSlot: ReactNode
    /** nextjs prints the bare number here, not the "N followers" phrase. */
    followersLabel: string
}

export const CollectionHeroFollow = ({
    followSlot,
    followersLabel,
}: TCollectionHeroFollowProps) => (
    <div data-test={COLLECTION_HERO_FOLLOW_TEST_ID} className={styles.follow}>
        {followSlot}
        <div className={styles.followers}>
            <UserGroupIcon width={20} height={20} className={styles.icon} />
            <p className={styles.count}>{followersLabel}</p>
        </div>
    </div>
)
